import React from 'react';
import { motion } from 'framer-motion';
export function Transformation() {
  return <section className="py-14 px-4 bg-brand relative overflow-hidden" data-id="element-143">
      {/* Background texture/pattern */}
      <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,#000_1px,transparent_1px)] [background-size:20px_20px]" data-id="element-144" />

      <div className="container mx-auto max-w-4xl relative z-10" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-neutral-950 rounded-3xl p-8 md:p-12 shadow-2xl border border-neutral-800" data-id="element-146">
          <div className="text-brand font-bold uppercase tracking-widest mb-4 text-sm" data-id="element-147">
            Lo que cambia en 7 días
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12" data-id="element-148">
            <div data-id="element-149">
              <h3 className="text-2xl font-display text-neutral-500 mb-4" data-id="element-150">
                HOY
              </h3>
              <p className="text-lg text-neutral-400 leading-relaxed" data-id="element-151">
                Un síntoma extraño en tu gato te genera ansiedad y miedo. El
                pánico te paraliza y no sabés a quién recurrir ni qué hacer
                primero.
              </p>
            </div>

            <div className="relative" data-id="element-152">
              {/* Divider for desktop */}
              <div className="hidden md:block absolute -left-6 top-0 bottom-0 w-px bg-neutral-800" data-id="element-153" />

              <h3 className="text-2xl font-display text-white mb-4" data-id="element-154">
                EN UNA SEMANA
              </h3>
              <p className="text-lg text-white leading-relaxed font-medium" data-id="element-155">
                Después de leer esta guía y armar tu botiquín, vas a mirar a tu
                mascota con la tranquilidad de quien tiene un plan de rescate
                profesional en el bolsillo. La seguridad de saber que, pase lo
                que pase, vas a saber cómo reaccionar.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}